import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "M",
  "use": "M-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"M\"><title>M</title><path d=\"M12 15.4l3.3-8.8h2.4V18h-1.9V9.8L12.6 18h-1.3L8.1 9.7V18H6.2V6.6h2.5l3.3 8.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/M.svg
// module id = ZtGB
// module chunks = 6